import axiosClient from './axiosClient';
import type { ReviewGateDto } from '@/types/review';

export const reviewApi = {
  initializeGates: async (opportunityId: string): Promise<ReviewGateDto[]> => {
    const response = await axiosClient.post(`/opportunities/${opportunityId}/reviews/gates/initialize`);
    return response.data;
  },

  getGates: async (opportunityId: string): Promise<ReviewGateDto[]> => {
    const response = await axiosClient.get(`/opportunities/${opportunityId}/reviews/gates`);
    return response.data;
  },

  startGate: async (opportunityId: string, gateId: string, reviewerId: string): Promise<ReviewGateDto> => {
    const response = await axiosClient.post(
      `/opportunities/${opportunityId}/reviews/gates/${gateId}/start`,
      null,
      { params: { reviewerId } }
    );
    return response.data;
  },

  approveGate: async (opportunityId: string, gateId: string, feedback?: string): Promise<ReviewGateDto> => {
    const response = await axiosClient.post(
      `/opportunities/${opportunityId}/reviews/gates/${gateId}/approve`,
      feedback ? { feedback } : {},
    );
    return response.data;
  },

  rejectGate: async (opportunityId: string, gateId: string, feedback?: string): Promise<ReviewGateDto> => {
    const response = await axiosClient.post(
      `/opportunities/${opportunityId}/reviews/gates/${gateId}/reject`,
      feedback ? { feedback } : {},
    );
    return response.data;
  },

  changeGateOwner: async (
    opportunityId: string,
    gateId: string,
    newOwnerId: string,
  ): Promise<ReviewGateDto> => {
    const response = await axiosClient.put(
      `/opportunities/${opportunityId}/reviews/gates/${gateId}/change-owner`,
      null,
      { params: { newOwnerId } },
    );
    return response.data;
  },

  getGatesStatus: async (opportunityId: string): Promise<{ allApproved: boolean; nextGate?: string }> => {
    const response = await axiosClient.get(`/opportunities/${opportunityId}/reviews/gates/status`);
    return response.data;
  },
};
